import { PHYSICIAN_ROLE } from '@/constants/role'

export const routes = [
  {
    path: '/',
    redirect: '/login',
    meta: {
      hidden: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../v2/views/login/LoginView.vue'),
    meta: {
      title: 'Login',
      hidden: true,
      singlePage: true,
      public: true,
    },
  },
  {
    path: '/login/2fa',
    name: 'login-2fa',
    component: () =>
      import(/* webpackChunkName: "login" */ '../v2/views/login/2fa/TwoFactorAuthenticationLoginView.vue'),
    meta: {
      title: 'Login 2FA',
      hidden: true,
      singlePage: true,
      public: true,
    },
  },
  {
    path: '/login/2fa-no-code',
    name: 'login-2fa-no-code',
    component: () =>
      import(/* webpackChunkName: "login" */ '../v2/views/login/2fa/TwoFactorAuthenticationLoginNoCodeView.vue'),
    meta: {
      title: 'Login 2FA',
      hidden: true,
      singlePage: true,
      public: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "login" */ '../v2/views/login/ForgotPasswordView.vue'),
    meta: {
      title: 'Esqueceu a senha',
      hidden: true,
      singlePage: true,
      public: true,
    },
    props: (route) => ({ email: route.query.email }),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "reset-password" */ '../views/reset-password/ResetPasswordView.vue'),
    meta: {
      hidden: true,
      singlePage: true,
      public: true,
    },
    props: (route) => ({
      email: route.query.email,
      code: route.query.code,
    }),
  },
  {
    path: '/medical-registration',
    name: 'medical-registration',
    component: () =>
      import(
        /* webpackChunkName: "medical-registration" */ '../v2/views/medical-registration/MedicalRegistrationView.vue'
      ),
    meta: {
      hidden: true,
      singlePage: true,
      public: true,
    },
    props: (route) => ({ origin: route.query.origin, pharmaceuticalUuid: route.query.pharmaceuticalUuid }),
  },
  {
    path: '/medical-registration/kira',
    redirect: '/medical-registration',
    meta: {
      hidden: true,
    },
  },
  //Compatibility path
  {
    path: '/medical-registration/:pharmaceuticalUuid',
    name: 'medical-registration-with-pharmaceutical-uuid',
    component: () =>
      import(
        /* webpackChunkName: "medical-registration" */ '../v2/views/medical-registration/MedicalRegistrationView.vue'
      ),
    meta: {
      hidden: true,
      singlePage: true,
      public: true,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../v2/views/home/HomeView.vue'),
    meta: {
      title: 'Início',
      icon: 'house',
    },
  },
  {
    path: '/guided-attendance/:attendanceId',
    name: 'guided-attendance',
    component: () => import(/* webpackChunkName: "attendance" */ '../v2/views/attendance/GuidedAttendanceView.vue'),
    meta: {
      hidden: true,
      title: 'Novo Atendimento Médico Guiado',
    },
    props: (route) => ({
      attendanceId: parseInt(route.params.attendanceId),
    }),
  },
  {
    path: '/patient',
    name: 'patient',
    component: () => import(/* webpackChunkName: "patient" */ '../views/patient/PatientView.vue'),
    meta: {
      title: 'Pacientes',
      icon: 'patient',
      roles: [PHYSICIAN_ROLE],
      hideAdmin: true,
      tooltip:
        'Cadastre e veja todos os pacientes. Na página de cada paciente, acesse o histórico de atendimentos e crie novos atendimentos',
    },
  },
  {
    path: '/patient/:id',
    name: 'patient-attendences',
    component: () =>
      import(/* webpackChunkName: "patient" */ '../views/patient/patient-attendances/PatientAttendancesView.vue'),
    meta: {
      title: 'Atendimentos',
      roles: [PHYSICIAN_ROLE],
      hidden: true,
      parent: 'patient',
    },
    props: (route) => ({ id: parseInt(route.params.id) }),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileView.vue'),
    meta: {
      title: 'Perfil',
      hidden: true,
    },
  },
  {
    path: '/new-template',
    name: 'new-template',
    component: () =>
      import(/* webpackChunkName: "model-document" */ '../views/printing-template/PrintingTemplateView.vue'),
    meta: {
      title: 'Modelos de receituário',
      roles: [PHYSICIAN_ROLE],
      hidden: true,
    },
  },
  {
    path: '/physician',
    name: 'physician',
    component: () => import(/* webpackChunkName: "physician" */ '../views/admin/physician/PhysicianView.vue'),
    meta: {
      title: 'Médicos',
      icon: 'stethoscope',
      admin: true,
    },
  },
  {
    path: '/physician/create',
    name: 'physician-create',
    component: () => import(/* webpackChunkName: "physician" */ '../views/admin/physician/PhysicianSaveView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
  },
  {
    path: '/physician/:id/edit',
    name: 'physician-edit',
    component: () => import(/* webpackChunkName: "physician" */ '../views/admin/physician/PhysicianSaveView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({ physicianId: parseInt(route.params.id) }),
  },
  {
    path: '/medicine',
    name: 'medicine',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/medicine/MedicineView.vue'),
    meta: {
      title: 'Medicamentos',
      icon: 'pill',
      admin: true,
    },
  },
  {
    path: '/medicine/create',
    name: 'medicine-create',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/medicine/MedicineCreateView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
  },
  {
    path: '/medicine/:id/edit',
    name: 'medicine-edit',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/medicine/MedicineEditView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({ medicineId: parseInt(route.params.id) }),
  },
  {
    path: '/medicine/:medicineId/presentation',
    name: 'medicine-presentation',
    component: () =>
      import(/* webpackChunkName: "medicine" */ '../views/admin/medicine-presentation/MedicinePresentationView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({ medicineId: parseInt(route.params.medicineId) }),
  },
  {
    path: '/medicine/:medicineId/presentation/create',
    name: 'medicine-presentation-create',
    component: () =>
      import(
        /* webpackChunkName: "medicine" */ '../views/admin/medicine-presentation/MedicinePresentationCreateView.vue'
      ),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({ medicineId: parseInt(route.params.medicineId) }),
  },
  {
    path: '/medicine/:medicineId/presentation/:presentationId/edit',
    name: 'medicine-presentation-edit',
    component: () =>
      import(
        /* webpackChunkName: "medicine" */ '../views/admin/medicine-presentation/MedicinePresentationEditView.vue'
      ),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      medicineId: parseInt(route.params.medicineId),
      presentationId: parseInt(route.params.presentationId),
    }),
  },
  {
    path: '/medicine/:medicineId/presentation/:presentationId/treatment',
    name: 'treatment',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/treatment/TreatmentView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      medicineId: parseInt(route.params.medicineId),
      presentationId: parseInt(route.params.presentationId),
    }),
  },
  {
    path: '/medicine/:medicineId/presentation/:presentationId/treatment/create',
    name: 'treatment-create',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/treatment/TreatmentCreateView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      medicineId: parseInt(route.params.medicineId),
      presentationId: parseInt(route.params.presentationId),
    }),
  },
  {
    path: '/medicine/:medicineId/presentation/:presentationId/treatment/:treatmentId/edit',
    name: 'treatment-edit',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/treatment/TreatmentEditView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      medicineId: parseInt(route.params.medicineId),
      presentationId: parseInt(route.params.presentationId),
      treatmentId: parseInt(route.params.treatmentId),
    }),
  },
  {
    path: '/medicine/:medicineId/presentation/:presentationId/treatment/:treatmentId/posology',
    name: 'posology',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/posology/PosologyView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      medicineId: parseInt(route.params.medicineId),
      presentationId: parseInt(route.params.presentationId),
      treatmentId: parseInt(route.params.treatmentId),
    }),
  },
  {
    path: '/medicine/:medicineId/presentation/:presentationId/treatment/:treatmentId/posology/create',
    name: 'posology-create',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/posology/PosologyCreateView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      medicineId: parseInt(route.params.medicineId),
      presentationId: parseInt(route.params.presentationId),
      treatmentId: parseInt(route.params.treatmentId),
    }),
  },
  {
    path: '/medicine/:medicineId/presentation/:presentationId/treatment/:treatmentId/posology/:posologyId/edit',
    name: 'posology-edit',
    component: () => import(/* webpackChunkName: "medicine" */ '../views/admin/posology/PosologyEditView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      medicineId: parseInt(route.params.medicineId),
      presentationId: parseInt(route.params.presentationId),
      treatmentId: parseInt(route.params.treatmentId),
      posologyId: parseInt(route.params.posologyId),
    }),
  },
  {
    path: '/exam-protocol',
    name: 'exam-protocol',
    component: () =>
      import(/* webpackChunkName: "exam-protocol" */ '../views/admin/exam-protocol/ExamProtocolView.vue'),
    meta: {
      title: 'Protocolos de exame',
      icon: 'quick-reference',
      admin: true,
    },
  },
  {
    path: '/exam-protocol/create',
    name: 'exam-protocol-create',
    component: () =>
      import(/* webpackChunkName: "exam-protocol" */ '../views/admin/exam-protocol/ExamProtocolCreateView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
  },
  {
    path: '/exam-protocol/:id/edit',
    name: 'exam-protocol-edit',
    component: () =>
      import(/* webpackChunkName: "exam-protocol" */ '../views/admin/exam-protocol/ExamProtocolEditView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
  {
    path: '/lme-attachment/by-disease',
    name: 'lme-attachment_by-disease',
    component: () => import('../views/admin/lme-attachment/LmeAttachmentsByDiseaseView.vue'),
    meta: {
      title: 'Anexos LME',
      icon: 'pdf',
      admin: true,
    },
  },
  {
    path: '/lme-attachment/disease/:diseaseId/by-state',
    name: 'lme-attachment_disease_by-state',
    component: () => import('../views/admin/lme-attachment/LmeAttachmentsByStateView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      diseaseId: parseInt(route.params.diseaseId),
    }),
  },
  {
    path: '/lme-attachment/disease/:diseaseId/state/:stateId',
    name: 'lme-attachment_disease_state',
    component: () => import('../views/admin/lme-attachment/LmeAttachmentsByDiseaseAndStateView.vue'),
    meta: {
      hidden: true,
      admin: true,
    },
    props: (route) => ({
      diseaseId: parseInt(route.params.diseaseId),
      stateId: route.params.stateId,
    }),
  },
  {
    path: '/attendance-form-factory',
    name: 'attendance-form-factory',
    component: () =>
      import(
        /* webpackChunkName: "attendance-form-factory" */ '../v2/views/attendance-form-factory/AttendanceFormFactoryView.vue'
      ),
    meta: {
      title: 'Formulários de Atendimento',
      icon: 'hospital',
      admin: true,
    },
  },
  {
    path: '/attendance-form-factory/create',
    name: 'attendance-form-factory-create',
    component: () =>
      import(
        /* webpackChunkName: "attendance-form-factory-edit-view" */ '../v2/views/attendance-form-factory/AttendanceFormFactoryFormView.vue'
      ),
    meta: {
      title: 'Criar formulário de atendimento',
      admin: true,
      hidden: true,
    },
    props: (route) => ({ fromFormId: parseInt(route.query.fromFormId) || undefined }),
  },
  {
    path: '/attendance-form-factory/:id/edit',
    name: 'attendance-form-factory-edit',
    component: () =>
      import(
        /* webpackChunkName: "attendance-form-factory-form" */ '../v2/views/attendance-form-factory/AttendanceFormFactoryFormView.vue'
      ),
    meta: {
      title: 'Formulários de Atendimento',
      admin: true,
      hidden: true,
    },
    props: (route) => ({
      fromFormId: parseInt(route.params.id),
      isEdit: true,
      wasAlreadyPublished: route.query.wasAlreadyPublished === 'true',
    }),
  },
  {
    path: '/campaign',
    name: 'campaign',
    component: () => import('../views/admin/screening-campaign/ScreeningCampaignView.vue'),
    meta: {
      title: 'Campanhas',
      icon: 'groups',
      admin: true,
    },
  },
  {
    path: '/campaign/create',
    name: 'campaign-create',
    component: () => import('../views/admin/screening-campaign/ScreeningCampaignUpsertView.vue'),
    meta: {
      title: 'Criar campanha',
      admin: true,
      hidden: true,
    },
  },
  {
    path: '/campaign/:code/create',
    name: 'campaign-edit',
    component: () => import('../views/admin/screening-campaign/ScreeningCampaignUpsertView.vue'),
    meta: {
      title: 'Editar campanha',
      admin: true,
      hidden: true,
    },
    props: (route) => ({
      code: route.params.code,
    }),
  },
  {
    path: '/screening',
    name: 'screening',
    component: () => import(/* webpackChunkName: "screening" */ '../v2/views/screening/ScreeningsView.vue'),
    meta: {
      title: 'Novos pacientes',
      icon: 'search-physician',
    },
    props: (route) => ({
      page: parseInt(route.query.page) || undefined,
      status: route.query.status,
      uuid: route.hash.substring(1) || undefined,
    }),
  },
  {
    path: '/upload-attendance-photo/:uuid',
    name: 'upload-attendance-photo',
    component: () => import(/* webpackChunkName: "upload-attendance-photo" */ '../views/UploadAttendancePhotoView.vue'),
    meta: {
      hidden: true,
      singlePage: true,
      public: true,
    },
    props: (route) => ({
      attendanceShareTokenUuid: route.params.uuid,
    }),
  },
  {
    path: '/attendance-standalone-calculator/:uuid',
    name: 'attendance-standalone-calculator',
    component: () =>
      import(
        /* webpackChunkName: "attendance-standalone-calculator" */ '../views/attendance/AttendanceStandaloneCalculatorView.vue'
      ),
    meta: {
      hidden: true,
      singlePage: true,
      public: true,
    },
    props: (route) => ({
      attendanceShareTokenUuid: route.params.uuid,
    }),
  },
  {
    path: '/redirect/:url',
    name: 'redirect',
    component: () => import(/* webpackChunkName: "redirect" */ '../views/RedirectView.vue'),
    meta: {
      hidden: true,
      singlePage: true,
      public: true,
    },
    props: (route) => ({ url: route.params.url }),
  },
  {
    path: '*',
    name: 'other',
    component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFoundView.vue'),
    meta: {
      hidden: true,
      singlePage: true,
      public: true,
    },
  },
  // {
  //   path: '/medical-documents/prescription',
  //   name: 'prescription-document',
  //   component: () => import('../views/medical-documents/prescription/PrescriptionView.vue'),
  //   meta: {
  //     hidden: true,
  //     title: 'Receituário',
  //   },
  //   props: (route) => ({ onlyView: !!route.query.onlyView }),
  // },
  // {
  //   path: '/medical-documents/report',
  //   name: 'report-document',
  //   component: () => import('../views/medical-documents/report/ReportView.vue'),
  //   meta: {
  //     hidden: true,
  //     title: 'Relatório',
  //   },
  //   props: (route) => ({ onlyView: !!route.query.onlyView }),
  // },
  // {
  //   path: '/medical-documents/lme',
  //   name: 'lme-document',
  //   component: () => import('../views/medical-documents/lme/LmeView.vue'),
  //   meta: {
  //     hidden: true,
  //     title: 'LME',
  //   },
  //   props: (route) => ({ onlyView: !!route.query.onlyView }),
  // },
  // {
  //   path: '/attendance/:attendanceId/:phase?',
  //   name: 'attendance',
  //   component: () => import(/* webpackChunkName: "attendance" */ '../views/AttendanceFormView.vue'),
  //   meta: {
  //     hidden: true,
  //     title: 'Atendimento médico',
  //   },
  //   props: (route) => ({ attendanceId: parseInt(route.params.attendanceId), phase: route.params.phase }),
  // },
  // {
  //   path: '/new-attendance/:attendanceId',
  //   name: 'new-attendance',
  //   component: () => import(/* webpackChunkName: "attendance" */ '../views/attendance/Attendance.view.vue'),
  //   meta: {
  //     hidden: true,
  //     title: 'Novo Atendimento médico',
  //   },
  //   props: (route) => ({
  //     attendanceId: parseInt(route.params.attendanceId),
  //     phase: route.query.phase,
  //     goToQuestion: route.hash.substring(1),
  //   }),
  // },
  // {
  //   path: '/show-physicians',
  //   name: 'show-physicians',
  //   component: () => import(/* webpackChunkName: "show-physicians" */ '../views/ListPhysiciansView.vue'),
  //   meta: {
  //     hidden: true,
  //     public: true,
  //     singlePage: true,
  //   },
  // },
  // {
  //   path: '/patient/sign-up',
  //   name: 'patient-sign-up',
  //   component: () => import(/* webpackChunkName: "patient" */ '../views/patient/patient-sign-up/PatientSignUpView.vue'),
  //   meta: {
  //     title: 'Cadastrar novo paciente',
  //     roles: [PHYSICIAN_ROLE],
  //     hidden: true,
  //   },
  // },
  // {
  //   path: '/pharmaceutical',
  //   name: 'pharmaceutical',
  //   component: () => import(/* webpackChunkName: "pharmaceutical" */ '../views/PharmaceuticalView.vue'),
  //   meta: {
  //     title: 'Farmacêuticas',
  //     icon: 'hospital',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/disease',
  //   name: 'disease',
  //   component: () => import(/* webpackChunkName: "disease" */ '../views/DiseaseView.vue'),
  //   meta: {
  //     title: 'Patologias',
  //     icon: 'science',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/export-data',
  //   name: 'export-data',
  //   component: () => import(/* webpackChunkName: "oexport-data" */ '../views/ExportDataView.vue'),
  //   meta: {
  //     title: 'Exportação de dados',
  //     icon: 'dashboard',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/medicine-category',
  //   name: 'medicine-category',
  //   component: () => import(/* webpackChunkName: "medicine-category" */ '../views/MedicineCategoryView.vue'),
  //   meta: {
  //     title: 'Categoria de medicamentos',
  //     icon: 'medication',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/adverse-effects',
  //   name: 'adverse-effects',
  //   component: () => import(/* webpackChunkName: "medicine" */ '../views/AdverseEffectsView.vue'),
  //   meta: {
  //     title: 'Eventos adversos',
  //     icon: 'medical-prescription',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/user',
  //   name: 'user',
  //   component: () => import(/* webpackChunkName: "user" */ '../views/UserView.vue'),
  //   meta: {
  //     title: 'Usuários adm',
  //     icon: 'clinical-notes',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/pharmaceutical-parameters',
  //   name: 'pharmaceutical-parameters',
  //   component: () =>
  //     import(/* webpackChunkName: "pharmaceutical-parameters" */ '../views/PharmaceuticalParametersView.vue'),
  //   meta: {
  //     title: 'Parâmetros de Farmacêuticas',
  //     icon: 'corporative',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/cid',
  //   name: 'cid',
  //   component: () => import(/* webpackChunkName: "cid" */ '../views/CidView.vue'),
  //   meta: {
  //     title: 'CID',
  //     icon: 'patient',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/symptom',
  //   name: 'symptom',
  //   component: () => import(/* webpackChunkName: "symptom" */ '../views/SymptomView.vue'),
  //   meta: {
  //     title: 'Sintomas',
  //     icon: 'diagnosis',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/exam',
  //   name: 'exam',
  //   component: () => import(/* webpackChunkName: "exam" */ '../views/ExamView.vue'),
  //   meta: {
  //     title: 'Exames',
  //     icon: 'content-paste',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/stop-medicine-reason',
  //   name: 'stop-medicine-reason',
  //   component: () => import(/* webpackChunkName: "stop-medicine-reason" */ '../views/StopMedicineReasonView.vue'),
  //   meta: {
  //     title: 'Motivos de parada de medicamento',
  //     icon: 'medical-information',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/voucher',
  //   name: 'voucher',
  //   component: () => import(/* webpackChunkName: "voucher" */ '../views/VoucherView.vue'),
  //   meta: {
  //     title: 'Gestão de vouchers',
  //     icon: 'medical-information',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/triagem-virtual/:uuid',
  //   name: 'triagem-virtual',
  //   component: () => import(/* webpackChunkName: "triagem-virtual" */ '../views/VirtualScreeningView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  //   props: (route) => ({ virtualScreeningUuid: route.params.uuid }),
  // },
  // {
  //   path: '/patient-waiting-room/:uuid',
  //   name: 'patient-waiting-room',
  //   component: () => import(/* webpackChunkName: "patient-waiting-room" */ '../views/PatientWaitingRoomView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  //   props: (route) => ({ waitingRoomUuid: route.params.uuid }),
  // },
  // {
  //   path: '/infusion-clinics',
  //   name: 'infusion-clinics',

  //   component: () => import(/* webpackChunkName: "infusion-clinics" */ '../views/InfusionClinicsView.vue'),
  //   meta: {
  //     title: 'Clínicas de Infusão',
  //     icon: 'hospital',
  //     admin: true,
  //   },
  // },
  // {
  //   path: '/accept-terms',
  //   name: 'accept-terms',
  //   component: () => import(/* webpackChunkName: "accept-terms" */ '../views/AcceptTermsView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  //   props: (route) => ({ uuid: route.query.u, hashedCode: route.query.hashedCode, pharmaceuticalId: route.query.pid }),
  // },
  // {
  //   path: '/approve-physician/:physicianUuid/:clinicUuid',
  //   name: 'approve-physician',
  //   component: () => import(/* webpackChunkName: "approve-physician" */ '../views/ApprovePhysicianView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  //   props: (route) => ({ physicianUuid: route.params.physicianUuid, clinicUuid: route.params.clinicUuid }),
  // },
  // {
  //   path: '/meeting/:meetingId',
  //   name: 'meeting',
  //   component: () => import(/* webpackChunkName: "meeting" */ '../views/MeetingView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  // },
  // {
  //   path: '/survey/:uuid',
  //   name: 'survey',
  //   component: () => import(/* webpackChunkName: "meeting" */ '../views/PatientSurveyView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  //   props: (route) => ({ surveyUuid: route.params.uuid }),
  // },
  // {
  //   path: '/private-meeting/:meetingId',
  //   name: 'private-meeting',
  //   component: () => import(/* webpackChunkName: "private-meeting" */ '../views/MeetingPrivateView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //   },
  // },
  // {
  //   path: '/test',
  //   name: 'test',
  //   component: () => import(/* webpackChunkName: "test" */ '../views/TestView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: false,
  //     public: true,
  //   },
  // },
  // {
  //   path: '/physician-data/:personUuid',
  //   name: 'physician-data',
  //   component: () => import(/* webpackChunkName: "physician-data" */ '../views/PhysicianData.vue'),
  //   meta: {
  //     title: 'Dados médicos',
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  //   props: (route) => ({ personUuid: route.params.personUuid }),
  // },
  // {
  //   path: '/new-patient',
  //   name: 'new-patient',
  //   component: () => import(/* webpackChunkName: "show-physicians" */ '../views/patient/NewPatientView.vue'),
  //   meta: {
  //     hidden: true,
  //     title: 'Cadastrar novo paciente',
  //     breadcrumbs: [{ key: 'patient', name: 'Pacientes', to: { name: 'patient' } }],
  //   },
  // },
  // {
  //   path: '/icon-catalog',
  //   name: 'icon-catalog',
  //   component: () => import(/* webpackChunkName: "icon-catalog" */ '../v2/views/IconCatalogView.vue'),
  //   meta: {
  //     hidden: true,
  //     singlePage: true,
  //     public: true,
  //   },
  // },
]
